export default __webpack_public_path__ + "static/media/rain-day.8a980a51.svg";